import {
  ElementName,
  svgToBase64,
  TPointerEvent,
  Control,
  InteractiveFabricObject,
} from '@meitu/whee-infinite-canvas';

/**
 * AI 工具页画布的默认渲染样式配置。
 * 默认保持极简态：隐藏所有操作手柄与选中描边。
 */
const renderStyleOptions = {
  scale: [],
  rotate: [],
  selection: {
    borderWidth: 0,
    defaultSelectionColor: 'transparent',
    defaultMultiSelectionColor: 'transparent',
    defaultFrameSelectionColor: 'transparent',
    defaultImageSelectionColor: 'transparent',
    defaultTextSelectionColor: 'transparent',
    defaultContainerSelectionColor: 'transparent',
  },
};

const ROTATE_ICON = 'data:image/svg+xml;base64,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';

const getTRCursorIcon = (angle: number = 0) => `
<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g transform="rotate(${angle}, 16, 16)">
    <g filter="url(#filter0_d_22197_203047)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M18.1573 11.7594L11.2593 18.6573L9.1539 16.5519C9.0468 16.4448 8.86336 16.5108 8.849 16.6615L8.23914 23.0651C8.22847 23.1771 8.32243 23.271 8.43439 23.2604L14.838 22.6505C14.9888 22.6362 15.0547 22.4527 14.9476 22.3456L12.8422 20.2402L19.7401 13.3423L21.8456 15.4477C21.9527 15.5548 22.1361 15.4888 22.1505 15.338L22.7603 8.93444C22.771 8.82249 22.677 8.72853 22.5651 8.73919L16.1615 9.34905C16.0107 9.36342 15.9447 9.54685 16.0518 9.65396L18.1573 11.7594Z" fill="#1A1A1A"/>
    </g>
    <g filter="url(#filter1_d_22197_203047)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2594 18.6574L18.1574 11.7594L16.0519 9.65399C15.9448 9.54688 16.0108 9.36345 16.1616 9.34909L22.5652 8.73922C22.6771 8.72856 22.7711 8.82252 22.7604 8.93447L22.1506 15.3381C22.1362 15.4889 21.9528 15.5548 21.8456 15.4477L19.7402 13.3423L12.8423 20.2402L14.9477 22.3456C15.0548 22.4528 14.9889 22.6362 14.8381 22.6506L8.43447 23.2604C8.32252 23.2711 8.22856 23.1771 8.23922 23.0652L8.84909 16.6616C8.86345 16.5108 9.04688 16.4448 9.15399 16.5519L11.2594 18.6574ZM14.1086 20.2402L15.5809 21.7125C16.2235 22.3551 15.8277 23.4558 14.923 23.5419L8.51937 24.1518C7.84764 24.2158 7.28388 23.652 7.34786 22.9803L7.95772 16.5767C8.04389 15.6719 9.1445 15.2761 9.78713 15.9188L11.2594 17.3911L16.8911 11.7594L15.4188 10.2871C14.7761 9.64449 15.1719 8.54388 16.0767 8.45772L22.4803 7.84785C23.152 7.78388 23.7158 8.34764 23.6518 9.01936L23.0419 15.423C22.9558 16.3277 21.8551 16.7235 21.2125 16.0809L19.7402 14.6086L14.1086 20.2402Z" fill="white"/>
    </g>
  </g>
</svg>
`;

const getBRCursorIcon = (angle: number = 0) => `
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g transform="rotate(${angle}, 16, 16)">
    <g filter="url(#filter0_d_22197_203027)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M18.1573 20.2402L11.2593 13.3423L9.1539 15.4477C9.0468 15.5548 8.86336 15.4889 8.849 15.3381L8.23914 8.93449C8.22847 8.82254 8.32243 8.72858 8.43439 8.73924L14.838 9.34911C14.9888 9.36347 15.0547 9.5469 14.9476 9.65401L12.8422 11.7594L19.7401 18.6574L21.8456 16.5519C21.9527 16.4448 22.1361 16.5108 22.1505 16.6616L22.7603 23.0652C22.771 23.1771 22.677 23.2711 22.5651 23.2604L16.1615 22.6506C16.0107 22.6362 15.9447 22.4528 16.0518 22.3457L18.1573 20.2402Z" fill="#1A1A1A"/>
    </g>
    <g filter="url(#filter1_d_22197_203027)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2594 13.3423L18.1574 20.2402L16.0519 22.3456C15.9448 22.4527 16.0108 22.6362 16.1616 22.6505L22.5652 23.2604C22.6771 23.2711 22.7711 23.1771 22.7604 23.0652L22.1506 16.6616C22.1362 16.5108 21.9528 16.4448 21.8456 16.5519L19.7402 18.6573L12.8423 11.7594L14.9477 9.65398C15.0548 9.54687 14.9889 9.36344 14.8381 9.34908L8.43447 8.73921C8.32252 8.72855 8.22856 8.82251 8.23922 8.93446L8.84909 15.3381C8.86345 15.4888 9.04688 15.5548 9.15399 15.4477L11.2594 13.3423ZM14.1086 11.7594L15.5809 10.2871C16.2235 9.64449 15.8277 8.54387 14.923 8.45771L8.51937 7.84784C7.84764 7.78387 7.28388 8.34763 7.34786 9.01935L7.95772 15.4229C8.04389 16.3277 9.1445 16.7235 9.78713 16.0808L11.2594 14.6086L16.8911 20.2402L15.4188 21.7125C14.7761 22.3551 15.1719 23.4557 16.0767 23.5419L22.4803 24.1518C23.152 24.2157 23.7158 23.652 23.6518 22.9803L23.0419 16.5767C22.9558 15.6719 21.8551 15.2761 21.2125 15.9188L19.7402 17.3911L14.1086 11.7594Z" fill="white"/>
    </g>
  </g>
</svg>
`;

const SCALE_DEFAULT = {
  xSize: 8,
  ySize: 8,
  backgroundColor: '#fff',
  apply: [ElementName.IMAGE],
  icon: '',
  radius: {},
  shape: 'rectangle' as const,
  cursor: () => {},
  enableShiftFreeScaling: [ElementName.IMAGE],
};

/**
 * 可交互对象的选中态样式（对齐 SDK 画布体验）：
 * - 显示图片等元素的缩放手柄与旋转手柄
 * - 显示蓝色选中描边
 */
export const interactiveRenderStyleOptions = {
  rotate: [{
    key: 'mbm',
    show: true,
    shape: 'ellipse',
    xSize: 26,
    ySize: 26,
    offsetX: 0,
    offsetY: 21,
    backgroundColor: 'transparent',
    icon: ROTATE_ICON,
    apply: [ElementName.IMAGE],
    cursor: () => {},
  }],
  scale: [{
    ...SCALE_DEFAULT,
    key: 'tl',
    cursor: (
      _eventData: TPointerEvent,
      _control: Control,
      fabricObject: InteractiveFabricObject,
    ) => `url(${svgToBase64(getBRCursorIcon(fabricObject.angle))}) 16 16, auto`,
  }, {
    ...SCALE_DEFAULT,
    key: 'tr',
    cursor: (
      _eventData: TPointerEvent,
      _control: Control,
      fabricObject: InteractiveFabricObject,
    ) => `url(${svgToBase64(getTRCursorIcon(fabricObject.angle))}) 16 16, auto`,
  }, {
    ...SCALE_DEFAULT,
    key: 'bl',
    cursor: (
      _eventData: TPointerEvent,
      _control: Control,
      fabricObject: InteractiveFabricObject,
    ) => `url(${svgToBase64(getTRCursorIcon(fabricObject.angle))}) 16 16, auto`,
  }, {
    ...SCALE_DEFAULT,
    key: 'br',
    cursor: (
      _eventData: TPointerEvent,
      _control: Control,
      fabricObject: InteractiveFabricObject,
    ) => `url(${svgToBase64(getBRCursorIcon(fabricObject.angle))}) 16 16, auto`,
  }],
  selection: {
    borderWidth: 2,
    defaultSelectionColor: '#408FFF',
    defaultMultiSelectionColor: '#408FFF',
    defaultFrameSelectionColor: '#408FFF',
    defaultImageSelectionColor: '#408FFF',
    defaultTextSelectionColor: '#408FFF',
    defaultContainerSelectionColor: '#408FFF',
  },
};

export default renderStyleOptions;
